module.exports = __webpack_public_path__ + "static/img/sg1.a87c4bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/control2/sg1.png
// module id = VHAz
// module chunks = 7